import type VueRouter from 'vue-router';

/**
 * Represents the symbol for the RouterService.
 */
export const RouterService = Symbol('RouterService');

/**
 * Represents a router service that extends VueRouter.
 */
export type RouterService = VueRouter
